import keyMirror from 'keymirror';
export const PlaceholderText = 'Double click to edit';
export const FixedEditorWidth = 1920;
export const ZoomPercentageDefaultIndex = 16;
export const ZoomPercentages = {
  1: 100,
  2: 125,
  3: 150,
  4: 175,
  5: 200,
  6: 225,
  7: 250,
  8: 275,
  9: 300,
  10: 325,
  11: 350,
  12: 375,
  13: 400,
  14: 425,
  15: 450,
  16: 475,
  17: 525,
  18: 575,
  19: 625,
  20: 675,
  21: 725,
  22: 775,
  23: 825,
  24: 875,
  25: 925,
  26: 975,
  27: 1025,
  28: 1075,
  29: 1125,
  30: 1175,
  31: 1225,
  32: 1275,
  33: 1325,
  34: 1375,
  35: 1425,
  36: 1475,
  37: 1525,
  38: 1575,
  39: 1625,
  40: 1675,
};

export const ScrollTopForZoom = {
  1: 16,
  2: 18,
  3: 18,
  4: 20,
  5: 24,
  6: 28,
  7: 30,
  8: 36,
  9: 40,
  10: 44,
  11: 48,
  12: 52,
  13: 56,
  14: 60,
  15: 64,
  16: 70,
  17: 74,
  18: 78,
  19: 86,
  20: 94,
};

export const LineHeightPercentageDefaultIndex = 2;
export const LineHeightPercentages = {
  1: 100,
  2: 125,
  3: 150,
  4: 175,
  5: 200,
  6: 225,
  7: 250,
  8: 275,
  9: 300,
  10: 325,
};

export const ScrollTopMultipleForLineHeight = {
  1: 1,
  2: 1.25,
  3: 1.5,
  4: 1.75,
  5: 2,
  6: 2.25,
  7: 2.5,
  8: 2.75,
  9: 3,
};

export const PrompterWidthDefaultIndex = 12;
export const PrompterWidths = [
  0.5, 0.525, 0.55, 0.575, 0.6, 0.625, 0.65, 0.675, 0.7, 0.725, 0.75, 0.775,
  0.8, 0.825, 0.85, 0.875, 0.9, 0.925, 0.95, 0.975, 1,
];

export const AutoScrollEnabledDefault = false;
export const AutoScrollSpeedDefaultIndex = 23;

export const AutoScrollSpeeds = [
  {
    direction: 'up',
    interval: 1,
    displayValue: '-20',
    intervalAmount: 3.5,
    hotkey: 'shift+option+0, shift+alt+0',
  },
  {
    direction: 'up',
    interval: 1,
    displayValue: '-19',
    intervalAmount: 3,
    hotkey: 'shift+option+9, shift+alt+9',
  },
  {
    direction: 'up',
    interval: 1,
    displayValue: '-18',
    intervalAmount: 2.5,
    hotkey: 'shift+option+8, shift+alt+8',
  },
  {
    direction: 'up',
    interval: 1,
    displayValue: '-17',
    intervalAmount: 2,
    hotkey: 'shift+option+7, shift+alt+7',
  },
  {
    direction: 'up',
    interval: 1,
    displayValue: '-16',
    intervalAmount: 1.5,
    hotkey: 'shift+option+6, shift+alt+6',
  },
  {
    direction: 'up',
    interval: 1,
    displayValue: '-15',
    intervalAmount: 1,
    hotkey: 'shift+option+5, shift+alt+5',
  },
  {
    direction: 'up',
    interval: 2,
    displayValue: '-14',
    intervalAmount: 1,
    hotkey: 'shift+option+4, shift+alt+4',
  },
  {
    direction: 'up',
    interval: 4,
    displayValue: '-13',
    intervalAmount: 1,
    hotkey: 'shift+option+3, shift+alt+3',
  },
  {
    direction: 'up',
    interval: 6,
    displayValue: '-12',
    intervalAmount: 1,
    hotkey: 'shift+option+2, shift+alt+2',
  },
  {
    direction: 'up',
    interval: 8,
    displayValue: '-11',
    intervalAmount: 1,
    hotkey: 'shift+option+1, shift+alt+1',
  },
  {
    direction: 'up',
    interval: 10,
    displayValue: '-10',
    intervalAmount: 1,
    hotkey: 'shift+0',
  },
  {
    direction: 'up',
    interval: 12,
    displayValue: '-9',
    intervalAmount: 1,
    hotkey: 'shift+9',
  },
  {
    direction: 'up',
    interval: 14,
    displayValue: '-8',
    intervalAmount: 1,
    hotkey: 'shift+8',
  },
  {
    direction: 'up',
    interval: 16,
    displayValue: '-7',
    intervalAmount: 1,
    hotkey: 'shift+7',
  },
  {
    direction: 'up',
    interval: 20,
    displayValue: '-6',
    intervalAmount: 1,
    hotkey: 'shift+6',
  },
  {
    direction: 'up',
    interval: 24,
    displayValue: '-5',
    intervalAmount: 1,
    hotkey: 'shift+5',
  },
  {
    direction: 'up',
    interval: 28,
    displayValue: '-4',
    intervalAmount: 1,
    hotkey: 'shift+4',
  },
  {
    direction: 'up',
    interval: 36,
    displayValue: '-3',
    intervalAmount: 1,
    hotkey: 'shift+3',
  },
  {
    direction: 'up',
    interval: 48,
    displayValue: '-2',
    intervalAmount: 1,
    hotkey: 'shift+2',
  },
  {
    direction: 'up',
    interval: 60,
    displayValue: '-1',
    intervalAmount: 1,
    hotkey: 'shift+1',
  },
  {
    direction: 'down',
    interval: 60,
    displayValue: '1',
    intervalAmount: 1,
    hotkey: '1',
  },
  {
    direction: 'down',
    interval: 48,
    displayValue: '2',
    intervalAmount: 1,
    hotkey: '2',
  },
  {
    direction: 'down',
    interval: 36,
    displayValue: '3',
    intervalAmount: 1,
    hotkey: '3',
  },
  {
    direction: 'down',
    interval: 28,
    displayValue: '4',
    intervalAmount: 1,
    hotkey: '4',
  },
  {
    direction: 'down',
    interval: 24,
    displayValue: '5',
    intervalAmount: 1,
    hotkey: '5',
  },
  {
    direction: 'down',
    interval: 20,
    displayValue: '6',
    intervalAmount: 1,
    hotkey: '6',
  },
  {
    direction: 'down',
    interval: 16,
    displayValue: '7',
    intervalAmount: 1,
    hotkey: '7',
  },
  {
    direction: 'down',
    interval: 14,
    displayValue: '8',
    intervalAmount: 1,
    hotkey: '8',
  },
  {
    direction: 'down',
    interval: 12,
    displayValue: '9',
    intervalAmount: 1,
    hotkey: '9',
  },
  {
    direction: 'down',
    interval: 10,
    displayValue: '10',
    intervalAmount: 1,
    hotkey: '0',
  },
  {
    direction: 'down',
    interval: 8,
    displayValue: '11',
    intervalAmount: 1,
    hotkey: 'option+1, alt+1',
  },
  {
    direction: 'down',
    interval: 6,
    displayValue: '12',
    intervalAmount: 1,
    hotkey: 'option+2, alt+2',
  },
  {
    direction: 'down',
    interval: 4,
    displayValue: '13',
    intervalAmount: 1,
    hotkey: 'option+3, alt+3',
  },
  {
    direction: 'down',
    interval: 2,
    displayValue: '14',
    intervalAmount: 1,
    hotkey: 'option+4, alt+4',
  },
  {
    direction: 'down',
    interval: 1,
    displayValue: '15',
    intervalAmount: 1,
    hotkey: 'option+5, alt+5',
  },
  {
    direction: 'down',
    interval: 1,
    displayValue: '16',
    intervalAmount: 1.5,
    hotkey: 'option+6, alt+6',
  },
  {
    direction: 'down',
    interval: 1,
    displayValue: '17',
    intervalAmount: 2,
    hotkey: 'option+7, alt+7',
  },
  {
    direction: 'down',
    interval: 1,
    displayValue: '18',
    intervalAmount: 2.5,
    hotkey: 'option+8, alt+8',
  },
  {
    direction: 'down',
    interval: 1,
    displayValue: '19',
    intervalAmount: 3,
    hotkey: 'option+9, alt+9',
  },
  {
    direction: 'down',
    interval: 1,
    displayValue: '20',
    intervalAmount: 3.5,
    hotkey: 'option+0, alt+0',
  },
];

export const ReactWindowAutoScrollSpeeds = [
  {
    direction: 'up',
    interval: 1,
    displayValue: '-20',
    intervalAmount: 13,
  },
  {
    direction: 'up',
    interval: 1,
    displayValue: '-19',
    intervalAmount: 12,
  },
  {
    direction: 'up',
    interval: 1,
    displayValue: '-18',
    intervalAmount: 11,
  },
  {
    direction: 'up',
    interval: 1,
    displayValue: '-17',
    intervalAmount: 10,
  },
  {
    direction: 'up',
    interval: 1,
    displayValue: '-16',
    intervalAmount: 9,
  },
  {
    direction: 'up',
    interval: 1,
    displayValue: '-15',
    intervalAmount: 8,
  },
  {
    direction: 'up',
    interval: 2,
    displayValue: '-14',
    intervalAmount: 7,
  },
  {
    direction: 'up',
    interval: 4,
    displayValue: '-13',
    intervalAmount: 6.5,
  },
  {
    direction: 'up',
    interval: 6,
    displayValue: '-12',
    intervalAmount: 6,
  },
  {
    direction: 'up',
    interval: 8,
    displayValue: '-11',
    intervalAmount: 5.5,
  },
  {
    direction: 'up',
    interval: 10,
    displayValue: '-10',
    intervalAmount: 5,
  },
  {
    direction: 'up',
    interval: 12,
    displayValue: '-9',
    intervalAmount: 4.5,
  },
  {
    direction: 'up',
    interval: 14,
    displayValue: '-8',
    intervalAmount: 4,
  },
  {
    direction: 'up',
    interval: 16,
    displayValue: '-7',
    intervalAmount: 3.5,
  },
  {
    direction: 'up',
    interval: 20,
    displayValue: '-6',
    intervalAmount: 3,
  },
  {
    direction: 'up',
    interval: 24,
    displayValue: '-5',
    intervalAmount: 2.5,
  },
  {
    direction: 'up',
    interval: 28,
    displayValue: '-4',
    intervalAmount: 2,
  },
  {
    direction: 'up',
    interval: 36,
    displayValue: '-3',
    intervalAmount: 1.5,
  },
  {
    direction: 'up',
    interval: 48,
    displayValue: '-2',
    intervalAmount: 1,
  },
  {
    direction: 'up',
    interval: 60,
    displayValue: '-1',
    intervalAmount: 0.5,
  },
  {
    direction: 'down',
    interval: 60,
    displayValue: '1',
    intervalAmount: 0.5,
  },
  {
    direction: 'down',
    interval: 48,
    displayValue: '2',
    intervalAmount: 1,
  },
  {
    direction: 'down',
    interval: 36,
    displayValue: '3',
    intervalAmount: 1.5,
  },
  {
    direction: 'down',
    interval: 28,
    displayValue: '4',
    intervalAmount: 2,
  },
  {
    direction: 'down',
    interval: 24,
    displayValue: '5',
    intervalAmount: 2.5,
  },
  {
    direction: 'down',
    interval: 20,
    displayValue: '6',
    intervalAmount: 3,
  },
  {
    direction: 'down',
    interval: 16,
    displayValue: '7',
    intervalAmount: 3.5,
  },
  {
    direction: 'down',
    interval: 14,
    displayValue: '8',
    intervalAmount: 4,
  },
  {
    direction: 'down',
    interval: 12,
    displayValue: '9',
    intervalAmount: 4.5,
  },
  {
    direction: 'down',
    interval: 10,
    displayValue: '10',
    intervalAmount: 5,
  },
  {
    direction: 'down',
    interval: 8,
    displayValue: '11',
    intervalAmount: 5.5,
  },
  {
    direction: 'down',
    interval: 6,
    displayValue: '12',
    intervalAmount: 6,
  },
  {
    direction: 'down',
    interval: 4,
    displayValue: '13',
    intervalAmount: 6.5,
  },
  {
    direction: 'down',
    interval: 2,
    displayValue: '14',
    intervalAmount: 7,
  },
  {
    direction: 'down',
    interval: 1,
    displayValue: '15',
    intervalAmount: 8,
  },
  {
    direction: 'down',
    interval: 1,
    displayValue: '16',
    intervalAmount: 9,
  },
  {
    direction: 'down',
    interval: 1,
    displayValue: '17',
    intervalAmount: 10,
  },
  {
    direction: 'down',
    interval: 1,
    displayValue: '18',
    intervalAmount: 11,
  },
  {
    direction: 'down',
    interval: 1,
    displayValue: '19',
    intervalAmount: 12,
  },
  {
    direction: 'down',
    interval: 1,
    displayValue: '20',
    intervalAmount: 13,
  },
];

export const FullScreenEditorHeaderHeight = 79; //75 height + 4 box-shadow
export const ToolbarHeight = 60;
export const ToolbarWidth = 432;

export const ReadArrowTopStyleDefault = 120;
export const ReadArrowDefaultStyles = {
  fontSize: '150px',
  lineHeight: '0px',
  position: 'absolute',
};
export const ReadArrowMirroredStyles = {
  fontSize: '150px',
  lineHeight: '0px',
  position: 'absolute',
};

export const FontWeightDefault = 'regular';
export const FontWeights = keyMirror({
  regular: null,
  bold: null,
});

export const ScrollToIndexDefault = -1;
export const LastScrollToIndexDefault = -1;
export const FeaturedCapitalizationDefault = false;
export const FullScreenEnabledDefault = false;
export const PrompterItemInfoEnabledDefault = true;
export const PrompterSingleItemEnabledDefault = false;
export const PrompterRealtimeSubscriptionsEnabledDefault = false;
export const PrompterTextMirrorDefault = false;
export const PrompterTextVerticalMirrorDefault = false;
export const PrompterDisplayClocks = true;

export const populatePrompterSettingsWithDefaults = (userSettings) => {
  const settings = userSettings.toJS ? userSettings.toJS() : userSettings;

  const zoom = settings.featuredZoom;
  const lineHeight = settings.featuredLineHeight;
  const fontWeight = settings.featuredFontWeight;
  const capitalization = settings.featuredCapitalization;
  const singleItem = settings.prompterSingleItemEnabled;
  const itemInfo = settings.prompterItemInfoEnabled;
  const prompterRealTimeEditsEnabled = settings.prompterRealTimeEditsEnabled;

  return {
    zoom:
      zoom !== undefined ? zoom : ZoomPercentages[ZoomPercentageDefaultIndex],
    lineHeight:
      lineHeight !== undefined
        ? lineHeight
        : LineHeightPercentages[LineHeightPercentageDefaultIndex],
    fontWeight: fontWeight !== undefined ? fontWeight : FontWeightDefault,
    capitalization: capitalization !== undefined ? capitalization : false,
    singleItem: singleItem !== undefined ? singleItem : false,
    itemInfo: itemInfo !== undefined ? itemInfo : true,
    prompterRealTimeEditsEnabled:
      prompterRealTimeEditsEnabled !== undefined
        ? prompterRealTimeEditsEnabled
        : true,
  };
};
